import posthog from 'posthog-js';

/**
 * Capture an event in PostHog with default properties
 * @param {string} eventName 
 * @param {object} properties 
 * @param {string} userType 'parent' | 'practitioner' | 'guest'
 */
export const captureEvent = (eventName, properties = {}, userType = 'guest') => {
  const defaultProps = {
    platform: 'web',
    user_type: userType,
    ...properties,
  };

  posthog.capture(eventName, defaultProps);
};

export const identifyUser = (distinctId, userType = 'guest') => {
  posthog.identify(distinctId, {
    user_type: userType,
  });
};
